import "lightgallery.js/dist/css/lightgallery.css";
import { ReactNode } from 'react';
import { LightgalleryProvider } from "react-lightgallery";

export default function GalleryProvider({ children }: IGalleryProviderProps) {
    return (
        <LightgalleryProvider>
            {children}
        </LightgalleryProvider>
    );
}

interface IGalleryProviderProps {
    children: ReactNode;
}